<template>
  <button class="category-card" @click="$emit('select', category)">
    <span :style="{ background: category.color || '#f1edff' }">{{
      category.icon || "●"
    }}</span
    ><strong>{{ category.label || category.name }}</strong>
  </button>
</template>
<script>
export default {
  name: "CategoryCard",
  props: { category: Object },
  emits: ["select"],
};
</script>
<style scoped>
.category-card {
  min-height: 98px;
  border: 1px solid #eef1f6;
  border-radius: 18px;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 9px;
  box-shadow: 0 8px 22px rgba(39, 31, 79, 0.06);
  transition: 0.18s;
}
.category-card span {
  width: 54px;
  height: 54px;
  display: grid;
  place-items: center;
  border-radius: 17px;
  font-size: 27px;
}
.category-card strong {
  font-size: 12px;
  color: #0f172a;
}
</style>
